import { Text, TextExtendedProps } from 'grommet'

export const Warning = (props: TextExtendedProps) => {
    return <Text {...props} color='red' />
}